import { TUserType } from 'store/features/auth/types';

export enum USER_TYPES {
  unknown,
  autorized,
  unautorized,
}

// @see also
// 1. useUserTypes src/common/hooks/useUserTypes.ts
// 2. useIsAutorizedUser src/store/features/auth/selectors/userType.ts
// 3. isAutorizedUser src/common/utils/userTypes.ts - THIS
//
export const isAutorizedUser = (userType: TUserType) =>
  USER_TYPES.autorized === userType;

export const isUnautorizedUser = (userType: TUserType) =>
  USER_TYPES.unautorized === userType;

export const isUnknownUser = (userType: TUserType) =>
  USER_TYPES.unknown === userType;
